import React from 'react';
import { Box, Container, Typography, Grid,TextField, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import NavBar from './shared/NavBar';
import Footer from './shared/Footer';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';

const ContactCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  background: 'linear-gradient(135deg, #FFF8F3 0%, #FFF 100%)',
  borderRadius: '16px',
  border: '1px solid rgba(255,107,53,0.08)',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  '& svg': {
    color: '#FF6B35',
    fontSize: '2rem'
  }
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: '#FF6B35',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#FF6B35',
    },
  },
  '& .MuiFormLabel-root.Mui-focused': {
    color: '#FF6B35',
  }
}));

const Contact = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
    // TODO: Implement form submission
  };

  return (
    <Box>
      <NavBar />
      <Container>
        <Box sx={{ py: 8 }}>
          <Typography 
            variant="h2" 
            align="center" 
            gutterBottom
            sx={{ 
              fontWeight: 900,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
              color: '#1A1A1A',
              mb: 3
            }}
          >
            Get in Touch
          </Typography>
          <Typography 
            variant="h5" 
            align="center" 
            color="textSecondary" 
            sx={{ mb: 8, maxWidth: '800px', mx: 'auto' }}
          >
            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </Typography>

          <Grid container spacing={6}>
            <Grid item xs={12} md={5}>
              <Box sx={{ mb: 4 }}>
                <Typography variant="h4" gutterBottom sx={{ color: '#FF6B35', fontWeight: 'bold' }}>
                  Contact Information
                </Typography>
                <Typography variant="body1" sx={{ color: '#666', mb: 4 }}>
                  Reach out to us through any of these channels
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <ContactCard>
                  <WhatsAppIcon />
                  <Box>
                    <Typography variant="h6" sx={{ color: '#1A1A1A' }}>
                      WhatsApp
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666' }}>
                      +91 9958540416
                    </Typography>
                  </Box>
                </ContactCard>

                <ContactCard>
                  <EmailIcon />
                  <Box>
                    <Typography variant="h6" sx={{ color: '#1A1A1A' }}>
                      Email Us
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666' }}>
                      support@youngpresso.com
                    </Typography>
                  </Box>
                </ContactCard>

                <ContactCard>
                  <InstagramIcon />
                  <Box>
                    <Typography variant="h6" sx={{ color: '#1A1A1A' }}>
                      Instagram
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666' }}>
                      youngpresso_official
                    </Typography>
                  </Box>
                </ContactCard>
              </Box>
            </Grid>

            <Grid item xs={12} md={7}>
              <Box 
                component="form" 
                onSubmit={handleSubmit}
                sx={{
                  p: 4,
                  background: '#fff',
                  borderRadius: '16px',
                  boxShadow: '0 8px 24px rgba(255,107,53,0.08)',
                }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      fullWidth
                      label="First Name"
                      required
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      fullWidth
                      label="Last Name"
                      required
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <StyledTextField
                      fullWidth
                      label="Email"
                      required
                      type="email"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <StyledTextField
                      fullWidth
                      label="Subject"
                      required
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <StyledTextField
                      fullWidth
                      label="Message"
                      required
                      multiline
                      rows={4}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      sx={{
                        backgroundColor: '#FF6B35',
                        color: '#fff',
                        padding: '12px',
                        borderRadius: '30px',
                        '&:hover': {
                          backgroundColor: '#FF5722',
                        }
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default Contact;
